import { HeadCell } from 'shell/components/shared/table/types';
import * as yup from 'yup';
import { BatchDownloadAnprFileManagment } from './types';

export const validationBatchDownloadAnprFile = yup.object().shape({
  title: yup.string(),
  startDate: yup
    .date()
    .nullable()
    .typeError('Data non valida')
    .test('start-date', 'La data di inizio deve essere prima della data di fine', function (value) {
      const { endDate } = this.parent;
      if (endDate && value) {
        return new Date(value) <= new Date(endDate);
      }
      return true;
    }),
  endDate: yup
    .date()
    .nullable()
    .typeError('Data non valida')
    .test('end-date', 'La data di fine deve essere dopo la data di inizio', function (value) {
      const { startDate } = this.parent;
      if (startDate && value) {
        return new Date(value) >= new Date(startDate);
      }
      return true;
    }),
});

export const headCells: HeadCell<
  BatchDownloadAnprFileManagment,
  keyof BatchDownloadAnprFileManagment
>[] = [
  {
    id: 'title',
    label: 'Nome File',
  },
  {
    id: 'updateDate',
    label: 'Data Aggiornamento',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];
